import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

/**
 * Route guard that requires admin role.
 * Must be nested inside a ProtectedRoute (assumes user is authenticated).
 * Redirects to home page if user is not an admin.
 */
export function AdminRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!['admin', 'project_manager', 'super_admin'].includes(user?.role || '')) {
    return <Navigate to="/" replace />;
  }

  if (user?.tenantAccessMode === 'expired_read_only') {
    const allowed = location.pathname === '/admin/account/projects'
      || /^\/admin\/projects\/[^/]+(?:\/(?:overview|files))?\/?$/.test(location.pathname);
    if (!allowed) return <Navigate to="/admin/account/projects" replace />;
  }

  return <Outlet />;
}
